export default {
    'lg': 'Large',
    'sm': 'Small'
};
